import { createStyles, makeStyles } from '@material-ui/styles';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { Bank } from '@/api/dictionary';
import { NotificationMessage, Space } from '@/components';
import { MainLayout, StatusLayout } from '@/layout';
import { UIState } from '@/model/global/types';
import { makeSelectBank } from '@/model/invoice/selectors';
import { InvoiceUIState } from '@/model/invoice/types';
import { RootState } from '@/model/types';
import { BankView, InvoiceDetailsView } from '@/pages/invoice/components';

const useStyles = makeStyles(() =>
  createStyles({
    container: { overflow: 'auto', flexGrow: 1 },
  }),
);

const selectBank = makeSelectBank();

export const BankPage: React.FC<RouteComponentProps<{ ['0']: string }>> = ({
  match,
}: RouteComponentProps<{ ['0']: string }>) => {
  const classes = useStyles();
  const bankId = match.params['0'];
  const bank = useSelector<RootState, Bank | undefined>((state) => selectBank(state, bankId));
  if (!bank) {
    return (
      <StatusLayout status="failed" height={220}>
        <NotificationMessage severity="error" title={<FormattedMessage id="invoice.errors.bankNotFound.title" />}>
          <FormattedMessage id="invoice.errors.bankNotFound.content" />
        </NotificationMessage>
      </StatusLayout>
    );
  }
  return (
    <MainLayout
      minHeight={350}
      height={550}
      buttons={{
        back: `/${UIState.INVOICE}/${InvoiceUIState.DETAILS}`,
        logout: <FormattedMessage id="invoice.logout.button.title" />,
      }}
      header={{
        title: <FormattedMessage id="invoice.pages.details.title" />,
      }}
      footer={{
        component: <InvoiceDetailsView type="alt" />,
      }}
    >
      <Space direction="vertical" className={classes.container} size={3}>
        {bank && <BankView value={bank} />}
      </Space>
    </MainLayout>
  );
};

export default withRouter(BankPage);
